import AccordionPanel from './AccordionPanel'

const ExpandCollapseLinks = () => (
  <div className="cb-accordion-controls">
    <button className="expand-all btn cb-accordion-btn">Expand All</button>
    <span className="cb-separator"></span>
    <button className="collapse-all btn cb-accordion-btn">Collapse All</button>
  </div>
)

export default class Accordions extends Component {
  constructor() {
    super()
    this.container = createRef()
  }

  componentDidMount() {
    //make sure apricot initializes accordion, so accessibility elements are automatically added
    APRICOT.CBAccordion({ elem: this.container.current, multiOpen: true, animation: false })
  }

  render() {
    const { showExpandCollapse = false, id, panels } = this.props

    return (
      <div className="cb-accordion" ref={this.container}>
        {showExpandCollapse ? <ExpandCollapseLinks /> : null}
        <div className="cb-accordion-panels">
          {panels.map((p, i) => (
            <AccordionPanel key={i} {...p} id={id} />
          ))}
        </div>
      </div>
    )
  }
}
